Librarian.Modules.Communications = new Class({
    Extends: Librarian.Modules.Module,
    Binds: ["load", "onLoad", "applyFilters", "resize"],

    options: {
        classPrefix: "modules-communications-",
        height: "auto",
        minHeight: 300,
        gridWidth: 800,
        gridHeight: 305
    },

    datePickers: {},
    currentTab: "sent",
    grid: null,

    initialize: function(options, wrapperEl) {
        this.setOptions(options);
        this.parent(this.options, wrapperEl);
    },

    load: function() {
        if (!this.wrapperEl)
            return;

        this.parent();
        this.wrapperEl.addClass("ecomm-grid");

        var contentUrl = Librarian.path.getLayoutsPath() + "pages/communications.html";
        new Librarian.Request.HTML({
            url: contentUrl,
            update:  this.containerEl,
            onSuccess: this.onLoad
        }).send();
    },

    onLoad: function() {
        var contEl = $(this.containerEl),
            fromDateEl = contEl.getElement(".fromDate"),
            fromIconEl = contEl.getElement(".fromIcon"),
            toDateEl = contEl.getElement(".toDate"),
            toIconEl = contEl.getElement(".toIcon");

        this.datePickers["from"] = Librarian.Utils.setUpDatePicker2(fromDateEl, fromIconEl);
        this.datePickers["to"] = Librarian.Utils.setUpDatePicker2(toDateEl, toIconEl);

        var itemEl = contEl.getElement(".goButton");
        if (itemEl)
            itemEl.addOnClick(this.applyFilters, this);

        var gridPanel = contEl.getElement(".gridPanel");
        if (gridPanel)
            this.loadGrid(gridPanel);

        this.resize();
    },

    loadGrid: function(gridPanel) {
        var buttons = [
            { name: Librarian.Lang.getString("scheduled"), bclass: "gridTab", onclick: this.onGridTabClick.bind(this) },
            { name: Librarian.Lang.getString("sent"), bclass: "gridTab gridCurrentTab", onclick: this.onGridTabClick.bind(this) }
        ];

        if (Librarian.event.enableDrafts) {
            buttons.unshift({ name: Librarian.Lang.getString("drafts"), bclass: "gridTab", onclick: this.onGridTabClick.bind(this) });
        }

        this.grid = new omniGrid(gridPanel, {
            buttons: buttons,
            columnModel: this.getColumnModel(),
            url: this.getUrl(),
            pagination: true,
            serverSort: false,
            filterHide: true,
            filterHideCls: "hide",
            filterSelectedCls: "filter",
            alternaterows: true,
            showHeader: true,
            sortHeader: true,
            resizeColumns: true,
            multipleSelection: true,
            width: this.options.gridWidth,
            height: this.options.gridHeight,
            perPage: 20,
            includeTotal: false,
            resizable: false
        });

        this.grid.addEvent("dblclick", this.onRowDblClick.bind(this));
    },

    onGridTabClick: function(name, grid) {
        if (name == Librarian.Lang.getString("drafts"))
            this.currentTab = "drafts";
        if (name == Librarian.Lang.getString("scheduled"))
            this.currentTab = "scheduled";
        else if (name == Librarian.Lang.getString("sent"))
            this.currentTab = "sent";

        grid.options.url = this.getUrl();
        grid.setColumnModel(this.getColumnModel());
        grid.reload();

        grid.options.buttons.forEach(function(buttonObj) {
            if (buttonObj && buttonObj.element) {
                if (buttonObj.name == name) {
                    buttonObj.bclass = "gridTab gridCurrentTab";
                    buttonObj.element.className = "gridTab gridCurrentTab";
                }
                else {
                    buttonObj.bclass = "gridTab";
                    buttonObj.element.className = "gridTab";
                }
            }
        });
    },

    getUrl: function() {
        switch (this.currentTab) {
            case "drafts":
                return Librarian.path.getEventUrl("getschuevents") + "&out=dgrid&expand=1&est=9";
            case "scheduled":
                return Librarian.path.getEventUrl("getschuevents") + "&out=dgrid&expand=1";
            case "sent":
                return Librarian.path.getEventUrl("getaruevents") + "&out=dgrid&expand=1";
        }
    },

    getColumnModel: function() {
        switch (this.currentTab) {
            case "drafts":
                return this.getDraftsColumnModel();
            case "scheduled":
                return this.getScheduledColumnModel();
            case "sent":
                return this.getSentColumnModel();
        }
    },

    getDraftsColumnModel: function() {
        var draftColumns = [
            {
                header: Librarian.Lang.getString("subject"),
                dataIndex: "name",
                dataType: "string",
                width: 200
            },
            {
                header: Librarian.Lang.getString("date"),
                dataIndex: "exectime",
                dataType: "string",
                labelFunction: this.renderDateTimeString,
                width: 150,
                noResize: true
            }
        ];

        return draftColumns;
    },

    getScheduledColumnModel: function() {
        var scheduledColumns = [
            {
                header: Librarian.Lang.getString("to"),
                dataIndex: "to",
                dataType: "string",
                labelFunction: this.renderRecipients,
                width: 200
            },
            {
                header: Librarian.Lang.getString("subject"),
                dataIndex: "name",
                dataType: "string",
                width: 200
            },
            {
                header: Librarian.Lang.getString("event_senddate"),
                dataIndex: "exectime",
                dataType: "string",
                labelFunction: this.renderDateTimeString,
                width: 150,
                noResize: true
            },
            {
                header: Librarian.Lang.getString("expires"),
                dataIndex: "expirationdate",
                dataType: "string",
                labelFunction: this.renderDateString,
                width: 100,
                noResize: true
            }
        ];

        return scheduledColumns;
    },

    getSentColumnModel: function() {
        var sentColumns = [
            {
                header: Librarian.Lang.getString("to"),
                dataIndex: "to",
                dataType: "string",
                labelFunction: this.renderRecipients,
                width: 200
            },
            {
                header: Librarian.Lang.getString("subject"),
                dataIndex: "name",
                dataType: "string",
                width: 200
            },
            {
                header: Librarian.Lang.getString("event_senddate"),
                dataIndex: "exectime",
                dataType: "string",
                labelFunction: this.renderDateTimeString,
                width: 150,
                noResize: true
            },
            {
                header: Librarian.Lang.getString("expires"),
                dataIndex: "expirationdate",
                dataType: "string",
                labelFunction: this.renderDateString,
                width: 100,
                noResize: true
            },
            {
                header: Librarian.Lang.getString("opens"),
                dataIndex: "opencount",
                dataType: "number",
                width: 70,
                noResize: true
            },
            {
                header: Librarian.Lang.getString("clicks"),
                dataIndex: "clickcount",
                dataType: "number",
                width: 70,
                noResize: true
            },
            {
                header: Librarian.Lang.getPluralString("share", 2),
                dataIndex: "sharecount",
                dataType: "number",
                width: 70,
                noResize: true
            },
            {
                header: Librarian.Lang.getPluralString("download", 2),
                dataIndex: "downloadcount",
                dataType: "number",
                width: 110,
                noResize: true
            },
        ];

        return sentColumns;
    },

    renderDateTimeString: function(data, row, columnData) {
        var date = data[columnData.dataIndex];
        if (date)
            return Librarian.Utils.extractDateFromString(date).format("%m/%d/%Y %l:%M %p");
        else
            return "N/A";
    },

    renderDateString: function(data, row, columnData) {
        var date = data[columnData.dataIndex];
        if (date)
            return Librarian.Utils.extractDateFromString(date).format("%m/%d/%Y");
        else
            return "N/A";
    },

    renderRecipients: function(data /*, row, columnData*/) {
        if (!data.recipients || data.recipients.length == 0)
            return '';

        var str = data.recipients[0].email || data.recipients[0].name;
        if (data.recipients.length > 1)
            str += Librarian.Lang.getArgString("and_more", (data.recipients.length - 1));
        return str;
    },

    onRowDblClick: function(obj) {
        var row = obj.row, 
            grid = obj.target,
            eventInfo = grid.options.data[row];

        var detailWindow = new Librarian.EventDetailsWindow({ eventId: eventInfo.eventid, grid: this.grid });
        detailWindow.show();
    },

    applyFilters: function() {
        var contEl = $(this.containerEl);
        if (!contEl)
            return;

        var itemEl = contEl.getElement(".fromDate");
        if (itemEl)
            this.grid.options.startDate = itemEl.value;

        itemEl = contEl.getElement(".toDate");
        if (itemEl)
            this.grid.options.endDate = itemEl.value;

        var filterKey = '';
        itemEl = this.containerEl.getElement(".searchBox");
        if (itemEl)
            filterKey = itemEl.value;

        this.grid.search(filterKey);
    },

    closeDatePickers: function() {
        if (this.datePickers) {
            for (var key in this.datePickers) {
                if (this.datePickers[key])
                    this.datePickers[key].close();
            }
        }
    },

    resize: function() {
        var bodyHeight = this.wrapperEl.getStyle("height").toInt();
        if (this.headerEl)
            bodyHeight -= this.headerEl.getStyle("height").toInt();

        this.containerEl.setStyle("height", bodyHeight);

        if (this.grid) {
            var controlHeight = 40,
                contEl = $(this.containerEl);
            if (contEl) {
                var controlEl = contEl.getElement(".commDateControls");
                if (controlEl)
                    controlHeight = controlEl.getHeight();
            }

            var width = contEl.getWidth() - contEl.getStyle("paddingLeft").toInt() - contEl.getStyle("paddingRight").toInt();
            var height = bodyHeight /* - controlHeight - 40 */ - contEl.getStyle("paddingBottom").toInt();

            this.grid.setSize(width, height);
        }
    }
});